import React, { ReactNode, useCallback, useMemo } from 'react';
import TagIcon from 'icons/Tag.icon';
import CalculatorIcon from 'icons/Calculator.icon';
import DiscountIcon from 'icons/Discount.icon';
import { Listing } from 'models/Listing';
import InformationcircleIcon from 'icons/Informationcircle.icon';
import { useTranslation } from 'react-i18next';
import { getIntegerValue } from './utils';
import { mapValueToMoneyFormat } from 'utils';

type KeyDetailsOption = {
  icon?: ReactNode;
  text: string;
  value?: string | number;
  popupText?: string;
  popupIcon?: ReactNode;
};

export default function useGetKeyDetailsOptions(
  listing: Partial<Listing>,
  isFixed: boolean,
  isEOI: boolean,
  adjEBITDA: number,
) {
  const { t } = useTranslation();

  const getMoneyValue = useCallback((value: string | number) => {
    if (!value) return null;
    return mapValueToMoneyFormat(getIntegerValue(value));
  }, []);

  return useMemo(
    () =>
      [
        {
          icon: <TagIcon />,
          text: 'priceGuide',
          value: isEOI
            ? t('eoi')
            : isFixed
            ? getMoneyValue(listing?.amount)
            : getMoneyValue(listing?.amountFrom),
        },
        {
          icon: <CalculatorIcon />,
          text: 'revenue',
          value: getMoneyValue(listing?.revenue),
        },
        {
          icon: <DiscountIcon />,
          text: 'adjEBITDA',
          popupText: 'adjEBITDATooltip',
          value: getMoneyValue(adjEBITDA),
          popupIcon: <InformationcircleIcon />,
        },
      ] as KeyDetailsOption[],
    [adjEBITDA, isEOI, isFixed, listing, getMoneyValue, t],
  );
}
